export function safeDecodeURI (str) {
    str = str || ''
    try {
        str = decodeURIComponent(str)
    } catch { /* empty */ }

    return str
}